import UAParser from "ua-parser-js";

const ua = new UAParser();

export default ua;
